function addAddressIfValid(address) {
  if (
    !address ||
    !address.line1 ||
    !address.locality ||
    !address.postal_code ||
    !address.country_id
  ) {
    return {};
  }

  return address;
}

function preparePayment(
  clientId,
  amount,
  currency,
  cartItems,
  selectedDeposits,
  paymentMethod,
  paymentSpecificData,
  billing,
  shipping,
) {
  return {
    client_id: clientId,
    order_id: cartItems?.[0]?.order_id,
    amount,
    currency: currency?.toUpperCase(),
    type: selectedDeposits.length ? "deposit" : "full",
    payment_method: paymentMethod,
    ...paymentSpecificData,
    billing_address_id: billing?.id,
    billing_address: addAddressIfValid(billing || {}),
    shipping_address_id: shipping?.id,
    shipping_address: addAddressIfValid(shipping || {})
  };
}

function prepareDepositPayment(selectedDeposits) {
  return {
    deposits: selectedDeposits.map((deposit) => ({
      id: deposit.itemId,
      amount: deposit.amount,
      name: deposit.name,
    })),
  };
}

function prepareOrderPayment(referralCode) {
  return {
    referral_code: referralCode,
  };
}

export function preparePaymentData(
  clientId,
  amount,
  currency,
  cartItems,
  selectedDeposits,
  paymentMethod,
  paymentSpecificData,
  referralCode,
  billing,
  shipping,
) {
  const paymentData = preparePayment(
    clientId,
    amount,
    currency,
    cartItems,
    selectedDeposits,
    paymentMethod,
    paymentSpecificData,
    billing,
    shipping,
  );

  const rest = paymentData.type === 'deposit' ?
    prepareDepositPayment(selectedDeposits) :
    prepareOrderPayment(referralCode, shipping);

  return {
    ...paymentData,
    ...rest,
  };
}

